var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9545 7.37673H16.9468L12.3573 0.465483C11.9391 -0.155161 11.0295 -0.155161 10.6218 0.465483L6.03227 7.37673H1.04545C0.470455 7.37673 0 7.8501 0 8.42867C0 8.52334 0.0104545 8.61801 0.0418181 8.71269L2.69727 18.4642C2.93773 19.3478 3.74273 20 4.70455 20H18.2955C19.2573 20 20.0623 19.3478 20.3132 18.4642L22.9686 8.71269L23 8.42867C23 7.8501 22.5295 7.37673 21.9545 7.37673ZM11.4895 2.94806L14.4273 7.37673H8.55182L11.4895 2.94806ZM11.5 15.7922C10.35 15.7922 9.40909 14.8455 9.40909 13.6884C9.40909 12.5312 10.35 11.5845 11.5 11.5845C12.65 11.5845 13.5909 12.5312 13.5909 13.6884C13.5909 14.8455 12.65 15.7922 11.5 15.7922Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.0ce916fa1e9479ff334f80595e9a42f7.svg";
export { ForwardRef as ReactComponent };